import { createDataAttribute } from "next-sanity"

interface ProjectCreditsProps {
	credits?: string
	client?: string
	recognition?: string
	disciplines?: any
	documentId: string
	_key: string
}

export default function ProjectCredits({credits, client, recognition, disciplines, documentId, _key}:ProjectCreditsProps) {
	return (
		<div
			className="section col-span-full my-section"
			key={_key}
			data-sanity={createDataAttribute({
				id: documentId,
				type: 'project',
				path: `contentBlocks[_key=="${_key}"]`,
			}).toString()}
		>
			<div className="site-grid">
				{(credits || client) && <div className="col-span-full md:col-span-3">
					<div className="text-lg/120 -tracking-20 space-y-6">
						{credits && <div className="section">
							<h3 className='text-grey dark"text-grey-dark'>Credits</h3>
							<ul>
								{credits?.split("\n")?.map((person, index) => (
									<li key={`person-${index}`}>{person}</li>
								))}
							</ul>
						</div>}
						{client && <div className="section">
							<h3 className='text-grey dark"text-grey-dark'>Client</h3>
							<ul>
								{client?.split("\n")?.map((client, index) => (
									<li key={`client-${index}`}>{client}</li>
								))}
							</ul>
						</div>}
					</div>
				</div>}
				{(disciplines?.length > 0 || recognition) && <div className="col-span-full md:col-span-3 mt-6 md:mt-0">
					<div className="text-lg/120 -tracking-20 space-y-6">
						{disciplines?.length > 0 && <div className="section">
							<h3 className='text-grey dark"text-grey-dark'>{disciplines?.length > 1 ? "Services" : "Service"}</h3>
							<ul>
								{disciplines?.map((discipline, index) => (
									<li key={`discipline-${index}`}>{discipline?.title}</li>
								))}
							</ul>
						</div>}
						{recognition && <div className="section">
							<h3 className='text-grey dark"text-grey-dark'>Recognition</h3>
							<ul>
								{recognition?.split("\n")?.map((award, index) => (
									<li key={`award-${index}`}>{award}</li>
								))}
							</ul>
						</div>}
					</div>
				</div>}
			</div>
		</div>
	)
}